import { groupBy, map, orderBy } from "lodash";
import React  from "react";
import { TApiParameter } from "../../../api/endpoints/Parameter";
import { LeveledParam } from "../../../entities/LeveledParam";

interface IProps {
  value: Array<LeveledParam>;
  params: {
    [shortname: string]: TApiParameter
  }
}

const ParamLevelist = (props: IProps) => {
  const { value, params } = props;

  const grouped = groupBy(value, 'param');

  return (
    <div className="param-levelist-formatter">
      {
        map(grouped, (group, shortname) => {
          const shortnameLowerCase = shortname.toLowerCase();
          const matchedParam = params[shortnameLowerCase];

          return (
            <div className="group" key={shortname}>
              <div className="header">
                {
                  matchedParam ?
                    `${matchedParam.name} (${shortnameLowerCase}):`
                    : `${shortnameLowerCase}:`
                }
              </div>
              <div className="values">
                {
                  orderBy(group, param => param.level).map(param => param.level).join(', ')
                }
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default ParamLevelist;
